import * as React from "react"
import { graphql } from "gatsby"
import Full from "../components/page-layouts/full"
import Columns from "../components/page-layouts/columns"
import SEOHead from "../components/head"
import { PageProps } from "../types"
import { ArchivePageProps } from "../types"

const layouts = {
  full: Full,
  columns: Columns
}

export interface _ArchivePageProps {
    data: {
      page: PageProps
    }
  }

export default function ArchivePage(props: any) {
    const { page } = props.data    
    const Component = layouts[page.layout]
    return <Component {...(props as any)} />
}

export const Head = (props: ArchivePageProps) => {
    const { page } = props.data
    const seoTitle = page.metadata?.title || page.title
    const seoDescription = page.metadata?.description
    return <SEOHead title={seoTitle} description={seoDescription} />
}

export const query = graphql`
  query PageContent($id: String!) {
    page(id: { eq: $id }) {
      id
      layout
      title
      hidePageTitle
      subtitle
      slug
      backgroundOverlayColor {
        red
        blue
        green
        alpha
      }
      backgroundOverlayOpacity
      pageBackground {
        id
        title
        ... on DatoCmsAsset {
          gatsbyImageData(
            imgixParams: {crop: "focalpoint", fit: "crop", w: "1600", h: "900"}
          )
        }
      }
      metadata {
        title
        description
      }
      heroImage {
        id
        title
        ... on DatoCmsAsset {
          gatsbyImageData(
            imgixParams: {crop: "focalpoint", fit: "crop", w: "2400", h: "900"}
          )
        }
      }
      heroImageAttribution
      heroOverlayColor {
        red
        blue
        green
        alpha
      }
      heroOverlayOpacity
      showPageHero
      showPageHeroVideo
      heroVideoYoutubeUrl
      title
      content {
        ...BlockContent
      }
    }
  }
`